import Quotes from "../../components/dashboard/Quotes";

export const QuotesDashboard = () => {
  return <Quotes />;
};
